import React, { useState } from 'react'
import {
  Button,
  Modal,
  TextArea,
  Checkbox
} from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl, FormattedMessage } from 'react-intl'
import messages from './messages'
import useCurrentUser from 'hooks/useCurrentUser'

export default NiceModal.create(({taskId, supplier_note_internal, supplier_note_external}) => {
  const { roles = [] } = useCurrentUser()
  const modal = useModal()
  const [internalComment, setInternalComment] = useState(supplier_note_internal ? supplier_note_internal.trim() : '')
  const [externalComment, setExternalComment] = useState(supplier_note_external ? supplier_note_external.trim() : '')
  const [loading, setLoading] = useState(false)
  const { formatMessage } = useIntl()

  const onSubmit = () => {
    setLoading(true)
    fetch(`/rest/v2/task/${taskId}/supplier-note`, { 
        method: 'PUT',
        body: JSON.stringify({
          supplier_note_internal: internalComment.trim(),
          supplier_note_external: externalComment.trim()
        }) 
      })
      .then((response) => response.json())
      .then((response) => {
        if (!response.success) {
          toastr.error(response.errors.join(', '))
        } else {
          toastr.success(formatMessage(messages.updateSuccess))
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => {
        setLoading(false)
        modal.resolve()
        modal.remove()
      })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.modalTitle)}
      dialogPanelClasses="max-w-screen-xl"
    >
      <div className="space-y-4">
        {(roles.includes('coordinator') || roles.includes('coordinator')) ? (
          <div className='space-y-2'>
            <TextArea
              label={formatMessage(messages.internalComment)}
              value={internalComment}
              rows={6}
              onChange={({ target: { value } }) => setInternalComment(value)}
            />
            <div className='text-center pt-8'>
              <Button variant="outline" onClick={() => setExternalComment(internalComment)}>
                <FormattedMessage {...messages.copy} />
              </Button>
            </div>
            <TextArea
              description={formatMessage(messages.externalCommentDescription)}
              label={formatMessage(messages.externalComment)}
              value={externalComment}
              rows={6}
              onChange={({ target: { value } }) => setExternalComment(value)}
            />
            <div className='text-right'>
              <Button onClick={() => onSubmit()}>
                {loading ? <FormattedMessage {...messages.loading} /> : <FormattedMessage {...messages.update} />}
              </Button>
            </div>
          </div>
        ) : (
          <div className='space-y-2'>
            <p className='whitespace-pre-wrap'>{externalComment}</p>
            <div className='text-right'>
              <Button onClick={() => modal.remove()}>
                <FormattedMessage {...messages.close} />
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
})
